import { ConsentInput, UiPermission } from './types';
export function mergeConsent({
  cookie,
  gtm
}: {
  cookie: Partial<ConsentInput>;
  gtm: ConsentInput | null;
}): ConsentInput {
  return Object.assign({}, gtm, cookie) as ConsentInput;
}
export const shallowEqualConsent = <T extends ConsentInput | UiPermission | null,>(a: T, b: T): boolean => {
  if (!a || !b) return false;
  return Object.entries(a).every(([key, value]) => b[key as keyof ConsentInput] === value);
};